import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { Button } from '@saviynt/design-system';
import useStyles from './styles/MigrationStep.styles';

function MigrationStep({ step, index, totalSteps }) {
  const classes = useStyles();

  const connectorClasses = [classes.connector, step.completed && classes.connectorCompleted]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      <div className={`${classes.step} ${step.completed ? classes.stepCompleted : ''}`}>
        <div className={classes.content}>
          <div className={`${classes.badge} ${step.completed ? classes.badgeCompleted : ''}`}>
            {step.completed ? '✓' : step.number}
          </div>
          <div className={classes.body}>
            <Typography variant="h6" className={classes.title}>
              {step.title}
            </Typography>
            <Typography variant="body2" className={classes.description}>
              {step.description}
            </Typography>
          </div>
          {step.completed && <span className={classes.completedPill}>✓ Completed</span>}
          {step.showButton && (
            <Button
              onClick={step.action}
              isDisabled={step.disabled}
              kind="outlined"
              size="large"
              className={classes.button}>
              {step.buttonText}
            </Button>
          )}
        </div>
      </div>
      {index < totalSteps - 1 && <div className={connectorClasses} />}
    </>
  );
}

export default MigrationStep;

MigrationStep.propTypes = {
  step: PropTypes.shape({
    completed: PropTypes.bool,
    number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    title: PropTypes.string,
    description: PropTypes.string,
    showButton: PropTypes.bool,
    action: PropTypes.func,
    disabled: PropTypes.bool,
    buttonText: PropTypes.string,
  }).isRequired,
  index: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
};
